import { render } from "./MistakeItem.vue?vue&type=template&id=5aa2a136"
import script from "./MistakeItem.vue?vue&type=script&lang=js"
export * from "./MistakeItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__